export const campaignHierarchy = {
  // business logic
  AfterLastVisit: {
    nonOTAVariant: 'AfterLastVisit',
    OTAVariant: 'OTAAfterVisit'
  },
  OTAAfterVisit: {
    isOTAcampaign: true,
    nonOTAVariant: 'AfterLastVisit',
    OTAVariant: 'OTAAfterVisit'
  },
  CheckedOutReview: {
    nonOTAVariant: 'CheckedOutReview',
    OTAVariant: 'OTACheckedOutReview'
  },
  OTACheckedOutReview: {
    isOTAcampaign: true,
    nonOTAVariant: 'CheckedOutReview',
    OTAVariant: 'OTACheckedOutReview'
  },
  JustBooked: {
    nonOTAVariant: 'JustBooked',
    OTAVariant: 'OTAJustBooked'
  },
  OTAJustBooked: {
    isOTAcampaign: true,
    nonOTAVariant: 'JustBooked',
    OTAVariant: 'OTAJustBooked'
  },
  Lost6Months: {
    nonOTAVariant: 'Lost6Months',
    OTAVariant: 'OTALost6Months'
  },
  OTALost6Months: {
    isOTAcampaign: true,
    nonOTAVariant: 'Lost6Months',
    OTAVariant: 'OTALost6Months'
  },
  Lost3Months: {
    nonOTAVariant: 'Lost3Months',
    OTAVariant: 'OTALost3Months'
  },
  OTALost3Months: {
    isOTAcampaign: true,
    nonOTAVariant: 'Lost3Months',
    OTAVariant: 'OTALost3Months'
  },
  Lost9Months: {
    nonOTAVariant: 'Lost9Months',
    OTAVariant: 'OTALost9Months'
  },
  OTALost9Months: {
    isOTAcampaign: true,
    nonOTAVariant: 'Lost9Months',
    OTAVariant: 'OTALost9Months'
  },
  Lost12Months: {
    nonOTAVariant: 'Lost12Months',
    OTAVariant: 'OTALost12Months'
  },
  OTALost12Months: {
    isOTAcampaign: true,
    nonOTAVariant: 'Lost12Months',
    OTAVariant: 'OTALost12Months'
  },
  Lost15Months: {
    nonOTAVariant: 'Lost15Months',
    OTAVariant: 'OTALost15Months'
  },
  OTALost15Months: {
    isOTAcampaign: true,
    nonOTAVariant: 'Lost15Months',
    OTAVariant: 'OTALost15Months'
  },
  Cancelled: {
    nonOTAVariant: 'Cancelled',
    OTAVariant: 'OTACancelled'
  },
  OTACancelled: {
    isOTAcampaign: true,
    nonOTAVariant: 'Cancelled',
    OTAVariant: 'OTACancelled'
  },
  NoShow: {
    nonOTAVariant: 'NoShow',
    OTAVariant: 'OTANoShow'
  },
  OTANoShow: {
    isOTAcampaign: true,
    nonOTAVariant: 'NoShow',
    OTAVariant: 'OTANoShow'
  },
  Lost15MonthsPlus: {
    nonOTAVariant: 'Lost15MonthsPlus',
    OTAVariant: 'OTALost15MonthsPlus'
  },
  OTALost15MonthsPlus: {
    isOTAcampaign: true,
    nonOTAVariant: 'Lost15MonthsPlus',
    OTAVariant: 'OTALost15MonthsPlus'
  }
}
